/* eslint-disable react/react-in-jsx-scope */
import CardTypeProject from "@/components/card-v2/CardTypeProject";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useModal } from "@/dashboard/store/store";
import useCheckIsDevice from "@/hooks/useDeviceType";
import i18n from "@/i18n";
import { useTypeProjectContext } from "@/programs/context/typeProgramContext";
import { CategoryProjectType } from "@/types";
import { FC, FormEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const AddProject: FC<{
  onHandleSubmit: (
    e: FormEvent<HTMLFormElement>,
    projectsTemp: any,
    setProjectsTemp: (item: any[]) => void
  ) => void;
}> = ({ onHandleSubmit }) => {
  const { setOpenModal, modals } = useModal();
  const [projectsTemp, setProjectsTemp] = useState<any[]>([]);
  const [projectsTempBdd, setProjectsTempBdd] = useState<any[]>([]);
  const defaultClass =
    "relative cursor-pointer rounded-[10px] font-[600] text-[#2D3720] bg-[rgba(194,194,194,0.1)] py-[10px] px-[15px]";
  const environnementalClass =
    "relative cursor-pointer rounded-[10px] font-[600] text-verdeoorange bg-[#f2f7ec]  py-[10px] px-[15px]";
  const socialClass =
    "relative cursor-pointer rounded-[10px] font-[600] text-verdeoorange bg-[#fff5ea]  py-[10px] px-[15px]";

  const { typesProject } = useTypeProjectContext();

  const { t } = useTranslation("dashboard", {
    keyPrefix: "Addproject",
  });

  const [projectsList, setProjectsList] = useState([]);

  const [filterActive, setFilterActive] = useState("all");
  const [typeActive, setTypeActive] = useState(1);
  const handleChangeType = (type) => {
    setTypeActive(type);

    setFilterActive("all");
    if (typesProject) {
      setProjectsList(typesProject.filter((project) => project.type == type));
    }
  };
  const onHandleOpen = () => {
    setOpenModal({ name: "project", value: !modals["project"] });
  };

  const [projectTypeTexts, setProjectTypeTexts] = useState(
    typesProject?.map((pt) => {
      return {
        name: pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
          ? pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
              ?.name
          : pt.name,
        description: pt.projectTypeLangs.find(
          (ptl) => ptl.lang.code === i18n.language
        )
          ? pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
              ?.description
          : pt.projectTypeLangs.find((ptl) => ptl.lang.code === "fr")
              ?.description,
        id: pt.id,
      };
    })
  );

  const itemsRef = useRef<HTMLDivElement[]>([]);

  const [parentTexts, setParentTexts] = useState(
    typesProject
      ?.map((item) => item.parent)
      .reduce((acc, parent) => {
        if (parent && !acc.some((existing) => existing.name === parent.name)) {
          acc.push(parent);
        }
        return acc;
      }, [])
      .map((pt) => {
        return {
          name: pt.projectTypeLangs.find(
            (ptl) => ptl.lang.code === i18n.language
          )
            ? pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
                ?.name
            : pt.name,
          id: pt.id,
        };
      })
  );
  useEffect(() => {
    if (!typesProject) return;

    const Typelang = typesProject.map((pt) => ({
      name:
        pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
          ?.name || pt.name,
      description:
        pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
          ?.description ||
        pt.projectTypeLangs.find((ptl) => ptl.lang.code === "fr")?.description,
      id: pt.id,
    }));

    const parentlang = typesProject
      .map((item) => item.parent)
      .reduce((acc, parent) => {
        if (parent && !acc.some((existing) => existing.name === parent.name)) {
          acc.push(parent);
        }
        return acc;
      }, [])
      .map((pt) => ({
        name:
          pt.projectTypeLangs.find((ptl) => ptl.lang.code === i18n.language)
            ?.name || pt.name,
        id: pt.id,
      }));

    setProjectTypeTexts(Typelang);
    setParentTexts(parentlang);
  }, [i18n.language, typesProject]);

  useEffect(() => {
    if (typesProject) {
      setProjectsList(typesProject?.filter((i) => i.type == 1));
    }
  }, [typesProject]);
  const handleFilterChange = (item) => {
    const projectUpdated =
      item == "all"
        ? typesProject.filter((i) => i.type == typeActive)
        : typesProject.filter((i) => {
            return i.parent.name == item && i.type == typeActive;
          });
    setProjectsList(projectUpdated);
    setFilterActive(item);
  };

  const handleChange = (item: string) => {
    const itemProject = typesProject?.find((project) => project.name === item);
    if (
      itemProject &&
      !projectsTemp.some((proj) => proj.name === itemProject.name)
    ) {
      setProjectsTemp([
        {
          name: itemProject.name,
          type: itemProject.id,
          icon: itemProject.icon,
        },
      ]);
      setProjectsTempBdd([
        {
          name: itemProject.name,
          type: itemProject.id,
          icon: itemProject.icon,
        },
      ]);
    }
  };

  const handleRemoveChange = (item: string) => {
    setProjectsTemp(projectsTemp.filter((project) => project.name != item));
    setProjectsTempBdd(
      projectsTempBdd.filter((project) => project.name != item)
    );
  };
  return (
    <div className="h-[170px] w-1/4 pr-8" id="addTypes">
      <Dialog open={modals["project"]} onOpenChange={onHandleOpen}>
        <DialogContent className="sm:h-[95vh] sm:max-w-[80vw] sm:overflow-hidden ">
          <DialogHeader className="justify-around">
            <DialogTitle asChild>
              <h2 className="mb-2 mt-5 flex items-center justify-center gap-4 text-center text-xl font-bold">
                {t("Typologie des projets")}
                {/* {isMobile && (
                  <Info onClick={() => setInfoVisible(!infoVisible)} />
                )} */}
              </h2>
            </DialogTitle>
            <DialogDescription asChild className="text-[#595959]">
              <p className="mb-0  text-center sm:mx-auto sm:max-w-[60vw]">
                {t(
                  `Chaque projet a une typologie unique, qui détermine les informations spécifiques à remplir. Un programme peut inclure plusieurs projets si celui-ci a plusieurs impacts. Chaque projet est conçu pour représenter un opérateur sur le terrain, afin de collecter les données le plus près possible de l'action. Si un projet couvre une vaste zone ou implique plusieurs intervenants, il peut être subdivisé en plusieurs projets pour une gestion plus précise.`
                )}
              </p>
            </DialogDescription>
          </DialogHeader>

          <div className="flex gap-2">
            <div
              onClick={() => handleChangeType(1)}
              className={typeActive === 1 ? environnementalClass : defaultClass}
            >
              {t("Type environnemental")}
              {typeActive === 1 && (
                <div
                  style={{ width: "calc(100% - 6px)" }}
                  className="absolute bottom-0 left-[3px] h-[3px] rounded-[2px] bg-verdeoorange"
                ></div>
              )}
            </div>
            <div
              onClick={() => handleChangeType(2)}
              className={typeActive === 2 ? socialClass : defaultClass}
            >
              {t("Type social")}
              {typeActive === 2 && (
                <div
                  style={{ width: "calc(100% - 6px)" }}
                  className="absolute bottom-0 left-[3px] h-[3px] rounded-[2px] bg-verdeoorange"
                ></div>
              )}
            </div>
          </div>

          <div
            className={`relative rounded-[20px] ${
              typeActive === 1 ? "bg-[#f2f7ec]" : "bg-[#fff5ea]"
            } p-[20px]`}
          >
            <div
              className={`${
                typeActive === 1 ? "bg-[#f2f7ec]" : "bg-[#fff5ea]"
              }`}
              style={{
                position: "absolute",
                top: "3px",
                left: typeActive === 1 ? "86px" : "246px",
                transform: "rotate(20deg)",
                width: "90px",
                height: "30px",
                zIndex: -1,
                borderRadius: "4px",
              }}
            ></div>
            <div
              className={`${
                typeActive === 1 ? "bg-[#f2f7ec]" : "bg-[#fff5ea]"
              }`}
              style={{
                position: "absolute",
                top: "3px",
                left: typeActive === 1 ? "15px" : "175px",
                transform: "rotate(-20deg)",
                width: "90px",
                height: "30px",
                zIndex: -1,
                borderRadius: "4px",
              }}
            ></div>
            <FilterProject
              projects={typesProject}
              parentTexts={parentTexts}
              onFilterChange={handleFilterChange}
              filterActive={filterActive}
              type={typeActive}
            />

            <form
              onSubmit={(e) => onHandleSubmit(e, projectsTemp, projectsTempBdd)}
            >
              <ScrollArea type="always" style={{ height: "calc(100vh - 430px)", marginBottom:"6em" }}>
                <div className="flex flex-wrap pt-4 sm:pb-52">
                  {projectsList?.map(
                    (item: CategoryProjectType, index: number) => {
                      return (
                        <div
                          ref={(el) => (itemsRef.current[index] = el)}
                          className="relative mb-4 basis-full px-4 md:basis-1/5"
                          key={item.id}
                        >
                          <CardTypeProject
                            icon={item.icon}
                            name={
                              projectTypeTexts?.find(
                                (ptt) => ptt.id === item.id
                              )?.name || item.name
                            }
                            description={
                              projectTypeTexts?.find(
                                (ptt) => ptt.id === item.id
                              )?.description || item.description
                            }
                            isActive={projectsTemp.some(
                              (project) => project.name === item.name
                            )}
                            type={item.type}
                          />
                          <Checkbox
                            className="absolute left-4 top-0 z-30 h-full opacity-0"
                            style={{ width: "calc(100% - 30px)" }}
                            onCheckedChange={(checked: boolean) => {
                              if (checked) {
                                handleChange(item.name);
                              } else {
                                handleRemoveChange(item.name);
                              }
                            }}
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              </ScrollArea>
              <div className="absolute bottom-0 left-0 z-50 flex w-full justify-center bg-gradient-to-t from-background to-background/0 py-8">
                <Button type="submit" disabled={projectsTempBdd.length === 0}>
                  {t("Suivant")}
                </Button>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const FilterProject = ({
  projects,
  parentTexts,
  onFilterChange,
  filterActive,
  type,
}) => {
  const { t } = useTranslation("submit", {
    keyPrefix: "project",
  });
  const isMobile = useCheckIsDevice("mobile");
  const parentsProjects = projects
    ?.map((item) => item.parent)
    .reduce((acc, parent) => {
      if (parent && !acc.some((existing) => existing.name === parent.name)) {
        acc.push(parent);
      }
      return acc;
    }, [])
    .filter((parent) => parent.type === type);

  const classActive =
    type === 1
      ? "hover:bg-verdeoorange bg-verdeoorange"
      : "hover:bg-verdeoorange bg-verdeoorange";

  return (
    <>
      {isMobile ? (
        <Carousel
          opts={{
            align: "start",
          }}
          className="mx-auto "
        >
          <CarouselContent className="w-[60vw]">
            {parentsProjects?.map((item, key: number) => (
              <CarouselItem key={key} className="basis-2/3 pl-2">
                <Badge
                  variant={item.name == filterActive ? "default" : "outline"}
                  onClick={() => onFilterChange(item.name)}
                  className={
                    "w-full cursor-pointer px-3 " +
                    (item.name == filterActive ? classActive : "")
                  }
                >
                  {parentTexts?.find((ptt) => ptt.id === item.id)?.name ||
                    item.name}
                </Badge>
              </CarouselItem>
            ))}
            <CarouselItem className="basis-2/3 pl-2">
              <Badge
                onClick={() => onFilterChange("all")}
                variant={filterActive == "all" ? "default" : "outline"}
                className={
                  "cursor-pointer " + (filterActive == "all" ? classActive : "")
                }
              >
                {t("Toutes")}
              </Badge>
            </CarouselItem>
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      ) : (
        <div className="mx-auto flex w-full flex-wrap justify-start gap-2">
          {parentsProjects?.map((item, key: number) => (
            <Badge
              key={key}
              variant={item.name == filterActive ? "default" : "outline"}
              onClick={() => onFilterChange(item.name)}
              className={
                "cursor-pointer " +
                (item.name == filterActive ? classActive : "")
              }
            >
              {parentTexts?.find((ptt) => ptt.id === item.id)?.name ||
                item.name}
            </Badge>
          ))}
          <Badge
            onClick={() => onFilterChange("all")}
            variant={filterActive == "all" ? "default" : "outline"}
            className={
              "cursor-pointer " + ("all" == filterActive ? classActive : "")
            }
          >
            {t("Toutes")}
          </Badge>
        </div>
      )}
    </>
  );
};

export default AddProject;
